export default __webpack_public_path__ + "static/share-context-53b8e12b5071c9ed64b3f0df062094ad.png";